import {z} from '@hono/zod-openapi';

/** A DMS request to load one profile's source facts and generate its calendar-month report. */
export const hondaMonthlyReportGenerationRequestSchema = z
  .object({
    authorizationProfileId: z.string().uuid(),
    reportMonth: z.number().int().min(1).max(12),
    reportYear: z.number().int().min(1000).max(9999),
  })
  .openapi('HondaMonthlyReportGenerationRequest');
export type HondaMonthlyReportGenerationRequest = z.infer<
  typeof hondaMonthlyReportGenerationRequestSchema
>;
